"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Registry_1 = __importDefault(require("./Registry"));
const Config_1 = __importDefault(require("../config/Config"));
const Logger_1 = require("../utils/Logger");
class Bundle {
    constructor(id, parent = new DummyBundle()) {
        this.injectables = new Registry_1.default();
        this.children = {};
        this.childrenName = [];
        if (!id) {
            (0, Logger_1.error)(`Invalid bundle id '${id}'.`);
        }
        this.id = id;
        this.parent = parent;
    }
    child(id) {
        if (!id) {
            (0, Logger_1.error)(`The value '${id}' is not valid as bundle id.`);
        }
        const lowerName = id.toLowerCase();
        let child = this.children[lowerName];
        if (!child) {
            child = this.children[lowerName] = {
                id,
                bundle: new Bundle(id, this),
            };
        }
        return child.bundle;
    }
    hasChild(id = '') {
        const lowerName = id.toLowerCase();
        return !!this.children[lowerName];
    }
    register(definition, args = {}) {
        this.checkHas(definition, args.name);
        return this.injectables.register(definition, args);
    }
    unregister(definition, args = {}) {
        return this.injectables.unregister(definition, args);
    }
    instantiate(def) {
        const { definition, args } = def;
        const argsCopy = Object.assign({}, args);
        return new definition(argsCopy);
    }
    checkHas(def, name) {
        return this.injectables.checkHas(def, name) || this.parent.checkHas(def, name);
    }
    has(def) {
        const name = typeof def === 'function' ? def.name : def;
        return this.injectables.has(name) || this.parent.has(name);
    }
    get(def) {
        return this.injectables.get(def) || this.parent.get(def);
    }
    getId(ref) {
        const str = Config_1.default.isStrict() ? String(ref) : String(ref).toLowerCase();
        return this.injectables.getId(ref) || this.parent.getId(ref) || str;
    }
}
exports.default = Bundle;
class DummyBundle {
    has() {
        return false;
    }
    checkHas() {
        return false;
    }
    get() {
        return null;
    }
    getId() {
        return null;
    }
}
//# sourceMappingURL=Bundle.js.map